// extracted by mini-css-extract-plugin
export default {"product-catalog__title":"product-catalog_product-catalog__title__SeT4E"};